import { CONSENT_APPS } from "../../consent/consent";
import { z } from "zod";

/** The receipt a browser posts after deciding. Public, so a bad body must 400. */
export const RecordConsentRequestSchema = z.object({
  /** Mirrors the browser's consent cookie. Never a user id. */
  consentId: z.uuid(),
  analytics: z.boolean(),
  /** Uncapped: a frontend deployed ahead of the API must not have receipts rejected. */
  policyVersion: z.number().int().nonnegative(),
  app: z.enum(CONSENT_APPS),
});
export type RecordConsentRequest = z.infer<typeof RecordConsentRequestSchema>;

/**
 * Whether this request's country requires a consent prompt. Public and
 * unauthenticated: the answer depends on the request IP, not on a user.
 */
export const GetConsentRegionResponseSchema = z.object({
  /** True when a banner must be shown before any non-essential tag loads. */
  requiresConsent: z.boolean(),
  /** ISO 3166-1 alpha-2 resolved at the edge, or null if unresolvable. */
  countryCode: z.string().nullable(),
});
export type GetConsentRegionResponse = z.infer<typeof GetConsentRegionResponseSchema>;
